// src/context/SmoothScrollContext.js
import React, { createContext, useContext, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

const SmoothScrollContext = createContext();

export const SmoothScrollProvider = ({ children }) => {
    const location = useLocation();

    const scrollTo = useCallback((targetId) => {
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
            const headerOffset = 100;
            const elementPosition = targetElement.offsetTop;
            const offsetPosition = elementPosition - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }
    }, []);

    const handleLinkClick = useCallback((e, targetId) => {
        e.preventDefault();
        // Si on est déjà sur la page d'accueil, on fait le scroll
        if (location.pathname === '/') {
            scrollTo(targetId);
        } else {
            // Sinon, on stocke la section cible dans sessionStorage et on redirige vers la page d'accueil
            sessionStorage.setItem('scrollTarget', targetId);
            window.location.href = '/';
        }
    }, [location.pathname, scrollTo]);

    // Hook d'initialisation pour vérifier s'il y a une cible de scroll stockée
    const checkStoredScrollTarget = useCallback(() => {
        const storedTarget = sessionStorage.getItem('scrollTarget');
        if (storedTarget) {
            // On attend un peu que le DOM soit complètement chargé
            setTimeout(() => {
                scrollTo(storedTarget);
                sessionStorage.removeItem('scrollTarget');
            }, 500);
        }
    }, [scrollTo]);

    const value = {
        scrollTo,
        handleLinkClick,
        checkStoredScrollTarget
    };

    return (
        <SmoothScrollContext.Provider value={value}>
            {children}
        </SmoothScrollContext.Provider>
    );
};

export const useSmoothScrollContext = () => {
    const context = useContext(SmoothScrollContext);
    if (context === undefined) {
        throw new Error('useSmoothScrollContext must be used within a SmoothScrollProvider');
    }
    return context;
};